
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form.header-inline-search');
  if (!form) return;

  const input = form.querySelector('input[type="search"]');
  if (!input) return;

  let timer;
  let controller;

  const dropdown = document.createElement('div');
  dropdown.className = 'header-product-suggestions';
  dropdown.hidden = true;
  dropdown.setAttribute('role', 'listbox');
  form.appendChild(dropdown);

  const style = document.createElement('style');
  style.textContent = `
  
form.header-inline-search {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 1px solid #d5d5d5;
  border-radius: 6px;
  background: #fff;
  overflow: visible !important;
  box-shadow: none;
}

form.header-inline-search input[type="search"] {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0 14px;
  border: 0;
  border-radius: 5px 0 0 5px;
  outline: none;
  background: transparent;
  color: #222;
  font-size: 14px;
  box-shadow: none;
  appearance: none;
  -webkit-appearance: none;
}



form.header-inline-search input[type="search"] {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 14px;
  margin: 0;
  border: 0;
  border-radius: 5px 0 0 5px;
  outline: none;
  background: transparent;
  color: #222;
  font-size: 14px;
  box-shadow: none;
}



form.header-inline-search button {
  width: 46px;
  height: 100%;
  flex: 0 0 46px;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0 5px 5px 0;
  background: #fff;
  color: #222;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}


    .header-product-suggestions {
      position: absolute;
      top: calc(100% + 1px);
      left: 0;
      width: 100%;
      box-sizing: border-box;
      max-height: 70vh;
      overflow-y: auto;
      background: #fff;
      color: #222;
      border: 1px solid #ddd;
      border-radius: 0 0 6px 6px;
      box-shadow: 0 6px 16px rgba(0,0,0,.14);
      z-index: 9999;
    }

    .header-product-suggestions[hidden] {
      display: none !important;
    }

    .header-suggestion-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 12px;
      color: #222;
      text-decoration: none;
      border-bottom: 1px solid #eee;
    }

    .header-suggestion-item:hover,
    .header-suggestion-item:focus {
      background: #f6f6f6;
    }

    .header-suggestion-item img {
      width: 52px;
      height: 58px;
      object-fit: contain;
      flex-shrink: 0;
    }

    .header-suggestion-details {
      display: flex;
      flex-direction: column;
      gap: 5px;
      min-width: 0;
    }

    .header-suggestion-title {
      font-size: 14px;
      line-height: 1.4;
    }

    .header-suggestion-price {
      font-size: 13px;
      font-weight: 600;
    }

    .header-suggestion-message {
      padding: 14px;
      font-size: 14px;
    }
  `;
  document.head.appendChild(style);

  function showMessage(message) {
    dropdown.replaceChildren();
    const item = document.createElement('div');
    item.className = 'header-suggestion-message';
    item.textContent = message;
    dropdown.appendChild(item);
    dropdown.hidden = false;
  }

  function formatPrice(value) {
    if (value == null || value === '') return '';
    const amount = Number(value) / 100;
    return Number.isFinite(amount)
      ? new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP'
        }).format(amount)
      : '';
  }

  function renderProducts(products) {
    dropdown.replaceChildren();

    if (!products.length) {
      showMessage('No products found');
      return;
    }

    products.forEach((product) => {
      const link = document.createElement('a');
      link.className = 'header-suggestion-item';
      link.href = product.url;
      link.setAttribute('role', 'option');

      const imageUrl =
        product.featured_image?.url ||
        product.featured_image ||
        product.image;

      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = product.title || '';
        img.loading = 'lazy';
        link.appendChild(img);
      }

      const details = document.createElement('span');
      details.className = 'header-suggestion-details';

      const title = document.createElement('span');
      title.className = 'header-suggestion-title';
      title.textContent = product.title || '';
      details.appendChild(title);

      link.appendChild(details);
      dropdown.appendChild(link);
    });

    dropdown.hidden = false;
  }

  input.addEventListener('input', () => {
    clearTimeout(timer);

    if (controller) controller.abort();

    const query = input.value.trim();

    if (query.length < 2) {
      dropdown.hidden = true;
      dropdown.replaceChildren();
      return;
    }

    timer = setTimeout(async () => {
      controller = new AbortController();
      showMessage('Searching…');

      try {
        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'last'
        });

        const response = await fetch(
          `/search/suggest.json?${params.toString()}`,
          { signal: controller.signal }
        );

        if (!response.ok) throw new Error('Search request failed');

        const data = await response.json();

        if (input.value.trim() !== query) return;

        renderProducts(data.resources?.results?.products || []);
      } catch (error) {
        if (error.name !== 'AbortError') {
          dropdown.hidden = true;
          console.error('Header predictive search:', error);
        }
      }
    }, 250);
  });

  input.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') dropdown.hidden = true;
  });

  document.addEventListener('click', (event) => {
    if (!form.contains(event.target)) dropdown.hidden = true;
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2 && dropdown.childElementCount) {
      dropdown.hidden = false;
    }
  });
});
